import { PresentationIcon } from "@sanity/icons"
import { defineField, defineType } from "@sanity-typed/types"
import { SanityValues } from "sanity.config"
import { imageWithAlt } from "schemas/chunks/imageAlt"
import { background } from "schemas/objects/helpers/background"
import { blockWithEmphasis } from "schemas/objects/helpers/blockWithEmphasis"
import Preview from "schemas/objects/helpers/Preview"
import { sizing } from "schemas/objects/helpers/sizing"

const type = defineType({
  type: "object",
  name: "mediaText4",
  title: "Media Text 4",
  icon: PresentationIcon,

  fieldsets: [...sizing.fieldsets, ...background.fieldsets],

  fields: [
    ...sizing.fields,
    ...background.fields,
    defineField({
      name: "contentTitle",
      title: "Content Title",
      type: "array",
      of: [blockWithEmphasis],
    }),
    defineField({
      name: "body",
      title: "Content Body",
      type: "array",
      of: [blockWithEmphasis],
    }),
    imageWithAlt,
    defineField({
      name: "position",
      title: "Media position",
      type: "string",
      initialValue: "left",
      options: {
        list: [
          { title: "Left", value: "left" },
          { title: "Right", value: "right" },
        ],
      },
    }),
    defineField({
      name: "hideMediaMobile",
      title: "Hide media on mobile",
      type: "boolean",
      initialValue: false,
    }),
    defineField({
      name: "style",
      title: "Style",
      type: "string",
      initialValue: "1",
      options: {
        list: [
          { title: "Color 1", value: "1" },
          { title: "Color 2", value: "2" },
        ],
      },
    }),
  ],

  components: {
    preview: () => <Preview title={type.title} icon={type.icon} />,
  },
})

export const mediaText4Schema = type
export type MediaText4 = SanityValues["mediaText4"]
